import React from 'react'

import { StyledContainer as S } from './Container.styles'

type TContainer = {
  children
}

export const Container: React.FC<TContainer> = ({ children }) => (
  <S.Container>{children}</S.Container>
)
